import { Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import confirmOrder from '../api/order/confirmOrder';
function FakePaymentPage() {
    const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
    const { orderId } = useParams();
    const navigate = useNavigate();
    const handleClicked = () => {
        const completeOrder = async () => {
            try {
                const responseData = await confirmOrder(orderId, 'Linepay');
                if (responseData.code === "000") {
                    console.log("ok");


                }
            } catch (err) {
                console.log(err);
            }
        }
        setIsPaymentProcessing(true);
        completeOrder();
        setTimeout(() => {

            navigate(`/app/order/orderResult/${orderId}`);

        }, 3000);
    }

    return (
        <div>
            <Typography fontSize={'h5'} align='center'>模擬付款頁面</Typography>
            <Button variant='outlined'  color="secondary" sx={{ color: '#004B97', border: '1px solid #ACD6FF' }} disabled={isPaymentProcessing} onClick={handleClicked}>付款</Button>
            <Typography fontSize={'h6'} align='center'>{isPaymentProcessing ? '付費處理中' : ''}</Typography>
        </div>
    );
}

export default FakePaymentPage;
